exports.default = {
  'title': '参考图选择',
  'selected_title': '选择图片',
  'selected_count': '已选择 {current}/{max} 张',
  'source_tabs': '图片来源',
  'open_picker': '选择参考图片',
  'image': '图片',
  'recent': '最近',
  'assets': '资产',
  'all_assets': '全部资产',
  'default_space': '默认空间',
  'folder_filter': '按文件夹筛选',
  'upload_action': '点击/拖拽上传',
  'upload_hint': 'PNG、JPG、JPEG、WebP，单张不超过 20 MB',
  'uploading': '上传中 {current}/{total}',
  'limit_reached': '已达上限',
  'image_alt': '参考图片',
  'remove': '移除',
  'remove_image': '移除图片 {name}',
  'select_image': '选择图片 {name}',
  'unselect_image': '取消选择图片 {name}',
  'unnamed': '未命名图片',
  'empty_recent': '暂无最近上传的图片',
  'empty_assets': '暂无图片资产',
  'load_failed': '图片加载失败',
  'loading_more': '正在加载更多...',
  'retry': '重试',
  'retry_folders': '重新加载文件夹',
  'retry_preview': '重试预览',
  'retry_image_preview': '重新加载图片 {name}',
  'loading_preview': '正在加载',
  'retry_load_more': '加载失败，点击重试',
  'unsupported_type': '{count} 张图片格式不受支持，已跳过',
  'file_too_large': '{count} 张图片超过 20 MB，已跳过',
  'remaining_limit': '当前还可选择 {count} 张图片',
  'max_count': '最多选择 {count} 张图片',
  'upload_failed': '{count} 张图片上传失败，请重试',
  'play_audio': '试听',
  'pause_audio': '暂停',
  'retry_audio': '重试试听',
  'stop_audio': '停止试听',
  'audio_audition': '音频试听',
  'audio_failed': '音频暂时无法播放，请重试试听或使用播放控件。',
  'media_selected_title': '选择素材',
  'media_selected_count': '已选择 {current}/{max} 项',
  'media_source_tabs': '素材来源',
  'media_remove_image': '移除素材 {name}',
  'media_select_image': '选择素材 {name}',
  'media_unselect_image': '取消选择素材 {name}',
  'media_unnamed': '未命名素材',
  'media_empty_recent': '暂无最近上传的素材',
  'media_empty_assets': '暂无素材资产',
  'media_load_failed': '素材加载失败',
  'media_retry_image_preview': '重新加载素材 {name}',
  'media_unsupported_type': '{count} 个素材格式不受支持，已跳过',
  'media_file_too_large': '{count} 个素材为空或超过 50MiB，已跳过',
  'media_remaining_limit': '当前还可选择 {count} 项素材',
  'media_max_count': '最多选择 {count} 项素材',
  'media_upload_failed': '{count} 个素材上传失败，请重试',
  'cancel': '取消',
  'confirm': '确认使用'
}
